<template>
  <table class="container table">
    <thead>
      <tr>
        <th v-for="(cell, index) in tableData.header" :key="index">{{ cell }}</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(row, index) in tableData.rows" :key="index">
        <th class="has-text-right">{{ row[0] }}</th>
        <td class="has-text-right" v-for="(cell, index) in row.slice(1)" :key="index">
          {{ Number(cell) >= 0.01 ? Number(cell).toFixed(2) : 0 }} %
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  name: "StatsTable",
  props: {
    simulations: {
      type: Array,
      required: true
    },
    statsType: {
      type: String,
      required: true
    }
  },
  computed: {
    statsTypeLabel() {
      const label = {
        damage: "Damage",
        "minimum-damage": "Minimum Damage"
      };
      return label[this.statsType];
    },
    validSimulations() {
      return this.simulations.filter(simulation => simulation.stats != null);
    },
    tableData() {
      const simulationStatsAttribute = {
        damage: "stats",
        "minimum-damage": "cumulativeStats"
      };
      const statsAttribute = simulationStatsAttribute[this.statsType];
      if (this.validSimulations.length === 0) {
        return { header: [this.statsTypeLabel], rows: [] };
      }
      const header = [this.statsTypeLabel].concat(
        this.validSimulations.map(simulation => simulation.label)
      );
      const numRows = Math.max(
        ...this.validSimulations.map(simulation =>
          Math.max(...Object.keys(simulation[statsAttribute]).map(key => Number(key)))
        )
      );
      const rows = [...Array(numRows + 1).keys()].map(damage =>
        [damage].concat(
          this.validSimulations.map(
            simulation => simulation[statsAttribute][damage] || 0
          )
        )
      );
      return {
        header: header,
        rows: rows
      };
    }
  }
};
</script>
